// CPI-974: the rules behind the CRM's cancel-booking form — a mandatory category and a mandatory
// written reason, Vietnam only. Why each rule is what it is, and why the helpers are here rather
// than in the modal, are in docs/merge-audit-main-svn-to-master.md, "Vietnam-only notes worth
// keeping (2026-09-06, CPI-974)".

// Equal to CANCELLATION_REASON_MAX_LENGTH in the Showroom's cancel modal.
export const CANCELLATION_REASON_MAX_LENGTH = 500;

export const CANCEL_BOOKING_BANK_FIELDS = [
  'bank_name',
  'bank_account_number',
  'bank_account_name',
];

// Returns error codes, not sentences; the modal resolves each one to a message.
export const validateCancelBookingForm = (form, hasBankFromContact) => {
  const errors = {};
  if (!form.cancellation_type) {
    errors.cancellation_type = 'select_cancellation_type';
  }
  if (!(form.cancellation_reason || '').trim()) {
    errors.cancellation_reason = 'field_required';
  }
  if (!hasBankFromContact) {
    CANCEL_BOOKING_BANK_FIELDS.forEach((key) => {
      if (!(form[key] || '').trim()) {
        errors[key] = 'field_required';
      }
    });
  }
  return errors;
};

// The requestRefund variables: the category travels as sr_cancellation_type, the typed text as
// sr_cancellation_reason.
export const buildRefundVariables = (opportunityId, opportunityData, form) => ({
  opportunity_id: opportunityId,
  sr_cancellation_type: form.cancellation_type,
  sr_cancellation_reason: form.cancellation_reason.trim(),
  sr_status: opportunityData?.sr_status || '',
  customer_id: opportunityData?.customer_id || '',
  bank_name: form.bank_name.trim(),
  bank_account_number: form.bank_account_number.trim(),
  bank_account_name: form.bank_account_name.trim(),
  name: opportunityData?.name || '',
  mobile_country_code: opportunityData?.mobile_country_code || '',
  mobile: opportunityData?.mobile || '',
});
